<template>
  <div class="choose-appointment-type-view">
    <div class="mb-3">
      <router-link to="/online-appointment">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
        {{ $t('navigation.back') }}
      </router-link>
    </div>
    <strong class="text-primary">{{ $t('choose_appointment_type.header') }}</strong>
    <div class="appointment-type-list mt-3">
      <div v-for="appointmentType in locationAppointmentTypes"
           :key="appointmentType.id"
           class="appointment-type-item"
      >
        <router-link
          class="appointment-type-card"
          :to="['/online-appointment', locationId, appointmentType.id].join('/')"
        >
          <strong class="d-inline-block pb-2">{{ appointmentType.name }}</strong><br>
          <span class="text-muted small">{{ appointmentType.duration }} {{ $t('choose_appointment_type.minutes') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'ChooseAppointmentTypeView',
  props: {
    locationId: {type: String, default: null},
  },
  computed: {
    ...mapState({
      appointmentTypes: state => state.Api.AppointmentTypes.all,
      locations: state => state.Api.Locations.all,
    }),
    location() {
      return this.locations.find(({id}) => id === this.locationId) ?? null;
    },
    locationAppointmentTypes() {
      return this.appointmentTypes.filter((appointmentType) => {
        if (appointmentType.location_id) {
          return appointmentType.location_id === this.locationId;
        }
        if (Array.isArray(appointmentType.locations)) {
          return appointmentType.locations.some(({id}) => id === this.locationId);
        }
        return true;
      });
    },
  },
  mounted() {
    if (!this.location) {
      this.$router.replace('/online-appointment');
      return;
    }
    if (this.locationAppointmentTypes.length === 1) {
      this.$router.replace(['/online-appointment', this.locationId, this.locationAppointmentTypes[0].id].join('/'));
    }
  },
};
</script>
